import { Skeleton } from "antd"
import React, { Suspense, lazy, useState } from "react"

import { type LeadChecklistItem } from "../../../types/lead.types.ts"
import { LeadViewChecklistView } from "./LeadViewChecklistView.tsx"

const LeadViewChecklistEdit = lazy(() => import("./LeadViewChecklistEdit.tsx"))

interface LeadViewChecklistProps {
  checklist: LeadChecklistItem[]
  saving?: boolean
  editAllowed?: boolean
  onUpdate: (checklist: LeadChecklistItem[]) => Promise<void>
}

export function LeadViewChecklist({
  checklist,
  saving,
  editAllowed,
  onUpdate
}: LeadViewChecklistProps) {
  const [editMode, setEditMode] = useState(false)
  const toggleEditMode = () => setEditMode(!editMode)

  return editMode ? (
    <Suspense fallback={<Skeleton.Node active className={"w-full h-96"} />}>
      <LeadViewChecklistEdit
        saving={saving}
        checklist={checklist}
        onCancel={toggleEditMode}
        onSubmit={onUpdate}
      />
    </Suspense>
  ) : (
    <LeadViewChecklistView
      checklist={checklist}
      editAllowed={editAllowed}
      onUpdate={onUpdate}
      onEdit={toggleEditMode}
    />
  )
}
